module.exports = __webpack_public_path__ + "img/@tmp_hrdcloud_08.ff22af8d.jpg";